const priceContracts: { cakeAddress: string, busdAddress: string, lpAddress: string } = {
  cakeAddress: '0x9393d3c08956f245cdee9ac9dd7214131ae2bb8b',
  busdAddress: '0xbb4CdB9CBd36B01bD1cBaEBF2De08d9173bc095c',
  lpAddress: '0x90Ebf5bF9e0486893deBC85Dcf164d1dDC107e0c'
}

export default priceContracts